import { useContext } from 'react'
import { ToastContext } from './context'

/**
 * Access the toast API from anywhere inside a {@link ToastProvider}.
 *
 * @returns {import('./types').ToastApi}
 */
export const useToast = () => {
  const ctx = useContext(ToastContext)
  if (!ctx) {
    throw new Error('useToast must be used within a <ToastProvider>')
  }
  return ctx
}
